import React from "react";
import {useEffect} from 'react';
import {useSelector,useDispatch} from 'react-redux';
import {Button, Tooltip, TextField} from '@material-ui/core';
import PluginModal from '../pluginModal.js'
import * as briefActions from '../../actions/briefActions';
import topic_lodash from 'lodash';
import {useParams} from 'react-router-dom';
import {api, isValidPermalink} from '../../utility';
import CloseIcon from '@material-ui/icons/Close';

function BriefCompletionButton(props){

  let { id } = useParams();
  const loggedInState = useSelector(state => state.auth);
  const currentPage = useSelector(state => state.currentPage);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [completedAt, setCompletedAt] = React.useState(new Date().toISOString().split('T')[0]);
  const [permalink, setPermalink] = React.useState("");
  const [isFormValid, setIsFormValid] = React.useState(true);
  
  const dispatch = useDispatch();

  useEffect(() => {
    setPermalink(currentPage.permalink);
  }, [currentPage.permalink]);


  // Check Permalink for validity, everytime it updates

  useEffect(()=>{
    if(permalink){
      // Check for permalink Pathnames, if the pathname does not exist, Disable the isValid flag for form
      if(isValidPermalink(permalink)){
        setIsFormValid(true);
      }else{
        setIsFormValid(false);
      }
    }else{
      setIsFormValid(false);
    }
  },[permalink]);

  // reset permalink if user closes modal
  useEffect(() => {
    if(!modalOpen){
      setPermalink(currentPage.permalink);
    }
  }, [modalOpen]);

  const handleOpenModal = () => {
    setModalOpen(true);
  }

  const handleMarkComplete = (e) => {
    e.preventDefault();
    dispatch(briefActions.markAdthriveBriefComplete({briefId: id, completedAt: completedAt, permalink: permalink, callback: (data) => {
        console.log('finished marking complete ', data);
        setModalOpen(false);
        props.handleFinishMarkComplete();
        // Delay content Call by 1.5 seconds to make sure we apply it after the we allow it to properly refresh
        setTimeout(()=>{
          props.updateContentCall();
        },1500)
    }}));
  }

  const handleClickCompleted = () => {
      window.open(api.ADTHRIVE_PUBDASH_BRIEFS(loggedInState.activeSite.id), '_blank');
  }

  let alreadyPublishedAt, hasCompleted, publishedDate;
  if(props.Briefs && props.Briefs.briefs && props.Briefs.briefs.data){
    let currentAdthriveBriefObj =  topic_lodash.find(props.Briefs.briefs.data, {id: id});
    if(currentAdthriveBriefObj){
        alreadyPublishedAt = currentAdthriveBriefObj.publishDate;
        hasCompleted = typeof alreadyPublishedAt === 'string';
        publishedDate = hasCompleted ? new Date(alreadyPublishedAt) : null;
    }
  }

  let buttonStyle = {
    textTransform: 'none'
  }
  let inputStyle = {
    marginBottom: '20px',
    width: '100%'
  }

  return(
      <React.Fragment>
      <div>
          {!hasCompleted && 
          <Tooltip title={(isFormValid)? "" : "Unable to mark this post as complete because it is either not published or the permalink is invalid. Please try publishing the post first or checking permalink settings."}>
            <span>
              <Button
                style={buttonStyle}
                color={(isFormValid)? "primary" : "grey"}
                disabled={!isFormValid}
                onClick={handleOpenModal}>
                  Mark Complete
              </Button>
            </span>
          </Tooltip>}
          {hasCompleted && <Tooltip title="Click to go to AdThrive dashboard to edit completion details">
            <Button
              style={buttonStyle}
              color="primary"
              onClick={handleClickCompleted}>
                Published on {`${publishedDate.getUTCMonth()+1}/${publishedDate.getUTCDate()}/${publishedDate.getUTCFullYear()}`}
            </Button>
          </Tooltip> }
      </div>
      <PluginModal
        open={modalOpen}
        onClose={() => { setModalOpen(false); }}
      >
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <form onSubmit={handleMarkComplete}>
            <div>
              <TextField
                  id="completedAt"
                  label="Date Published"
                  type="date"
                  defaultValue="2017-05-24"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {setCompletedAt(e.target.value)}}
                  value={completedAt}
                  style={inputStyle}
                  required
                />
            </div>
            <div>
              <TextField
                label="URL"
                onChange={(e) => {setPermalink(e.target.value)}}
                value={permalink}
                style={inputStyle}
                placeholder="https://www.blog.com/post"
                required
                type="url"
                disabled
              />
            </div>
            <Button variant="contained" color="primary" type="submit" style={{width: '100%'}}>
              Mark Complete
            </Button>
          </form>
        </div>
      </PluginModal>
      </React.Fragment>
  );

}

export default BriefCompletionButton;